export class ErrorHandler {
  public static errorResponseHandler(error: any) {
    window.hideLoader();
    return Promise.reject(error.response);
  }
}
